/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 一般処置
 */
export type TreatmentGeneralTreatmentsEnum =
  (typeof TreatmentGeneralTreatmentsEnum)[keyof typeof TreatmentGeneralTreatmentsEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentGeneralTreatmentsEnum = {
  MONITOR: 'MONITOR',
  ECG: 'ECG',
  O2: 'O2',
  SUCTION: 'SUCTION',
  FOREIGN_BODY_REMOVAL: 'FOREIGN_BODY_REMOVAL',
  AIRWAY_ESTABLISHMENT_MANUAL: 'AIRWAY_ESTABLISHMENT_MANUAL',
  AIRWAY_ESTABLISHMENT_BVM: 'AIRWAY_ESTABLISHMENT_BVM',
  AIRWAY_ORAL: 'AIRWAY_ORAL',
  AIRWAY_NASAL: 'AIRWAY_NASAL',
  CHEST_COMPRESSION_MANUAL: 'CHEST_COMPRESSION_MANUAL',
  CHEST_COMPRESSION_AUTO: 'CHEST_COMPRESSION_AUTO',
  HEMOSTASIS: 'HEMOSTASIS',
  COVERING: 'COVERING',
  WOUND_CARE: 'WOUND_CARE',
  CERVICAL_COLLAR: 'CERVICAL_COLLAR',
  SCOOP_STRETCHER: 'SCOOP_STRETCHER',
  PELVIC_STABILIZATION_SHEET: 'PELVIC_STABILIZATION_SHEET',
  PELVIC_STABILIZATION_INSTRUMENT: 'PELVIC_STABILIZATION_INSTRUMENT',
  DEFIBRILLATION: 'DEFIBRILLATION',
  ECG_TRANSMISSION: 'ECG_TRANSMISSION',
  AUSCULTATION: 'AUSCULTATION',
  O2_HIGH: 'O2_HIGH',
  O2_MEDIUM: 'O2_MEDIUM',
  O2_LOW: 'O2_LOW',
  SPO2_MEASUREMENT: 'SPO2_MEASUREMENT',
  DRUG_ADMINISTRATION: 'DRUG_ADMINISTRATION',
  GLUCOSE_ADMINISTRATION: 'GLUCOSE_ADMINISTRATION',
  EPIPEN_ADMINISTRATION: 'EPIPEN_ADMINISTRATION',
  GLUCOSE_MEASUREMENT: 'GLUCOSE_MEASUREMENT',
  BT_MEASUREMENT: 'BT_MEASUREMENT',
  BP_MEASUREMENT: 'BP_MEASUREMENT',
  BP_MAINTENANCE_WITH_SHOCK_PANTS: 'BP_MAINTENANCE_WITH_SHOCK_PANTS',
  AIRWAY_MANUAL: 'AIRWAY_MANUAL',
  VENTILATION_MANUAL: 'VENTILATION_MANUAL',
  VENTILATION_AUTOMATIC: 'VENTILATION_AUTOMATIC',
  AIRWAY_LARYNGOSCOPE_FORCEPS_SUCTION: 'AIRWAY_LARYNGOSCOPE_FORCEPS_SUCTION',
  AIRWAY_ESOPHAGEAL_OR_OROPHARYNGEAL_TUBE:
    'AIRWAY_ESOPHAGEAL_OR_OROPHARYNGEAL_TUBE',
  AIRWAY_INTUBATION: 'AIRWAY_INTUBATION',
  CHEST_COMPRESSION_AUTO_ON_SITE: 'CHEST_COMPRESSION_AUTO_ON_SITE',
  CHEST_COMPRESSION_AUTO_IN_VEHICLE: 'CHEST_COMPRESSION_AUTO_IN_VEHICLE',
  IV_LINE_ESTABLISHMENT_INFUSION: 'IV_LINE_ESTABLISHMENT_INFUSION',
  IV_ACCESS_BEFORE_CPA_GLUCOSE: 'IV_ACCESS_BEFORE_CPA_GLUCOSE',
  IV_ACCESS_BEFORE_CPA_SHOCK: 'IV_ACCESS_BEFORE_CPA_SHOCK',
  HEMOSTASIS_PRESSURE: 'HEMOSTASIS_PRESSURE',
  HEMOSTASIS_DEVICE: 'HEMOSTASIS_DEVICE',
  POSITION_MANAGEMENT: 'POSITION_MANAGEMENT',
  IMMOBILIZATION: 'IMMOBILIZATION',
  HEAD_STABILIZATION: 'HEAD_STABILIZATION',
  LOCAL_STABILIZATION: 'LOCAL_STABILIZATION',
  WARMING: 'WARMING',
  COOLING: 'COOLING',
  HOME_TREATMENT_INFUSION: 'HOME_TREATMENT_INFUSION',
  HOME_TREATMENT_EXTERNAL_FISTULA: 'HOME_TREATMENT_EXTERNAL_FISTULA',
  HOME_TREATMENT_OTHER: 'HOME_TREATMENT_OTHER',
  OTHER: 'OTHER',
} as const;
